import styled, { css } from "styled-components";

import {
  FormControl as MuiFormControl,
  InputLabel as MuiInputLabel,
  Select as MuiSelect,
  Radio,
  SelectProps,
} from "@mui/material";

import { Delete } from "@mui/icons-material";
import { HTMLAttributes } from "react";

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  border: solid 1px #0000003B;
`;

interface IRadioCardProps extends HTMLAttributes<HTMLDivElement> {
  selected: boolean;
  label: string;
}

export const RadioCard = ({ selected, label, ...rest }: IRadioCardProps) => {
  return (
    <Card style={{ borderColor: selected ? "#3024E1" : "#0000003B", cursor: "pointer" }} {...rest}>
      <Radio checked={selected} color="primary" />
      <span style={{ color: selected ? "#3024E1" : "#191C1A", fontWeight: selected ? "600" : "400", fontSize: "14px" }}>{label}</span>
    </Card>
  )
}